import { adapter } from './urlAdapter'
import CON_NAME_MAP_ID from 'common/assets/data/con'

// import config from './ENV'
import defaultConProd from './defaultCon'
// import defaultConDev from 'common/assets/data/dev'

// let defaultCon = config.ENV === 'prod' ? Object.assign({}, defaultConProd) : Object.assign({}, defaultConDev)

export default {
  dataRefreshRate: 5, // 数据缓存时间，单位：min,
  defaultCon: defaultConProd, // 一个会别默认指向的大会，如： qcon.infoq.cn => qcon.infoq.cn/beijing/2019
  adapter, // url 适配器
  CON_NAME_MAP_ID // 大会名字映射ID
  // testDataSource: `https://static-data.geekbang.org/democon/data.json`,
  // dataSource: `https://static-data.geekbang.org/qcongz2019/data.json`,
  // generateUrl: (year, location) => {
  // return `https://static-data.geekbang.org/${defaultConfig.con}${urlAdapter(location)}${year}/data.json`
  // }
}
